import { AllureEquipmentRequestStateTypes, AllureEquipmentRequestActionTypes } from "./AllureEquipmentRequest.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AllureEquipmentRequestStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const AllureEquipmentRequestReducer = (
  state: AllureEquipmentRequestStateTypes = INITIAL_STATE,
  action: any
): AllureEquipmentRequestStateTypes => {
  switch (action.type) {
    case AllureEquipmentRequestActionTypes.FETCH_ALL_ALLURE_EQUIPMENT_REQUEST:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureEquipmentRequestActionTypes.FETCH_ALL_ALLURE_EQUIPMENT_REQUEST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureEquipmentRequestActionTypes.FETCH_ALL_ALLURE_EQUIPMENT_REQUEST_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureEquipmentRequestActionTypes.FETCH_ALL_ALLURE_EQUIPMENT_REQUEST_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case AllureEquipmentRequestActionTypes.FETCH_ONE_ALLURE_EQUIPMENT_REQUEST:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureEquipmentRequestActionTypes.FETCH_ONE_ALLURE_EQUIPMENT_REQUEST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureEquipmentRequestActionTypes.FETCH_ONE_ALLURE_EQUIPMENT_REQUEST_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureEquipmentRequestActionTypes.FETCH_ONE_ALLURE_EQUIPMENT_REQUEST_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AllureEquipmentRequestReducer;
